import React from "react";
import "./Cards.css"; // Assuming the CSS is saved in App.css

const FuturisticCards = () => {
  const cards = [
    {
      id: 1,
      title: "1",
      description: "We engineer with purpose, precision, and passion.",
    },
    {
      id: 2,
      title: "2",
      description: "Sustainability and progress go hand in hand.",
    },
    {
      id: 3,
      title: "3",
      description:
        "Innovative tools & technologies unlock interactivity that feels magical.",
    },
    {
      id: 4,
      title: "4",
      description:
        "People do their best creative work when they feel safe & supported.",
    },
  ];

  return (
    <div className="card-container">
      {cards.map((card) => (
        <div key={card.id} className="cardd">
          <h2>{card.title}</h2>
          <p>{card.description}</p>
        </div>
      ))}
    </div>
  );
};

export default FuturisticCards;
